import axios from 'axios'
import Qs from 'qs'
import store from 'STORE/index'
import { pushLogins } from 'ROUTER/index'


import {
  saveAccessToken,
  getAccessToken,
  removeAccessToken,
  cachedAdminInfo,
  cachedWebInfo,
  cachedPublicInfo,
  removeAdminInfo
} from 'API/cacheService'

import {
  SET_ADMIN_INFO,
  SET_WEB_INFO,
  SET_PUBLIC_INFO
} from 'STORE/mutation-types'

/* eslint-disable */
const API_ROOT = 'https://tjxcx.saiqiwangluo.com/'
const API_ROOT_DEV = '/a'

/* eslint-enable */
axios.defaults.baseURL = (process.env.NODE_ENV === 'production' ? API_ROOT : API_ROOT_DEV)

axios.defaults.headers.Accept = 'application/json'

// axios拦截器 除登录、注册页面外全部添加token信息
axios.interceptors.request.use(function (config) {
  if (config.url.indexOf('a/') === 0 || config.url.indexOf('w/') === 0) {
    if (getAccessToken()) {
      config.headers['accesstoken'] = getAccessToken()
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// axios拦截器 验证token信息如果没有或者过期返回登录页面
axios.interceptors.response.use(function (response) {
  if (response.data.code < 0) {
    if (response.data.code === -4001) {
      // 清空登录信息、token、跳转登录页
      removeAdminInfo()
      removeAccessToken()
      pushLogins()
    }
    let error = {
      msg: response.data.msg
    }
    return Promise.reject(error)
  }
  return response.data
}, function (error) {
  error = {
    msg: '请求出错'
  }
  return Promise.reject(error)
})

export default {
  /**
   * 用户登录
   */
  webLogin (params) {
    return axios.post('u/login', Qs.stringify(params))
  },
  /**
   * 获取栏目信息
   */
  getColumn (params) {
    return axios.get('a/getColumn', Qs.stringify(params))
  },
  /**
   * 获取单个栏目信息
   */
  getOneColumn (params) {
    return axios.post('a/getOneColumn', Qs.stringify(params))
  },
  /**
   * 添加栏目
   */
  addColumn (params) {
    return axios.post('a/addColumn', Qs.stringify(params))
  },
  /**
   * 添加栏目
   */
  delfile (params) {
    return axios.post('a/delfile', Qs.stringify(params))
  },
  /**
   * 设置栏目
   */
  saveColumn (params) {
    return axios.post('a/saveColumn', Qs.stringify(params))
  },
  /**
   * 删除栏目
   */
  delColumn (params) {
    return axios.post('a/delColumn', Qs.stringify(params))
  },
  /**
   * 添加视频文章
   */
  addVideo (params) {
    return axios.post('a/addVideo', Qs.stringify(params))
  },
  /**
   * 获取视频栏目分类
   */
  getVideoType (params) {
    return axios.get('a/getVideoType', Qs.stringify(params))
  },
  /**
   * 视频文章分页获取
   */
  getArticleAllVideo (params) {
    return axios.post('a/getArticleAllVideo', Qs.stringify(params))
  },
  /**
   * 修改文章状态（视频）
   */
  saveArticleVideoState (params) {
    return axios.post('a/saveArticleVideoState', Qs.stringify(params))
  },
  /**
   * 删除文章（视频）
   */
  delArticleVideo (params) {
    return axios.post('a/delArticleVideo', Qs.stringify(params))
  },
  /**
   * 获取单个文章（视频）
   */
  getOneArticleVideo (params) {
    return axios.post('a/getOneArticleVideo', Qs.stringify(params))
  },
  /**
   * 修改文章内容（视频）
   */
  saveArticleVideo (params) {
    return axios.post('a/saveArticleVideo', Qs.stringify(params))
  },
  /**
   * 获取账号分页数据
   */
  getAdminAll (params) {
    return axios.post('a/getAdminAll', Qs.stringify(params))
  },
  /**
   * 删除账户
   */
  delAdmin (params) {
    return axios.post('a/delAdmin', Qs.stringify(params))
  },
  /**
   * 添加账户
   */
  addAdmin (params) {
    return axios.post('a/addAdmin', Qs.stringify(params))
  },
  /**
   * 设置账户状态
   */
  saveAdmin (params) {
    return axios.post('a/saveAdmin', Qs.stringify(params))
  },
  /**
   * 获取单个账户信息
   */
  getOneAdmin (params) {
    return axios.post('a/getOneAdmin', Qs.stringify(params))
  },
  /**
   * 设置账户信息
   */
  upAdmin (params) {
    return axios.post('a/upAdmin', Qs.stringify(params))
  },
  /**
   * 添加帮助信息
   */
  addHelp (params) {
    return axios.post('a/addHelp', Qs.stringify(params))
  },
  /**
   * 获取帮助信息ALL
   */
  getHelpAll (params) {
    return axios.get('a/getHelpAll', Qs.stringify(params))
  },
  /**
   * 获取单条帮助信息
   */
  getOneHelp (params) {
    return axios.post('a/getOneHelp', Qs.stringify(params))
  },
  /**
   * 修改帮助信息
   */
  upHelp (params) {
    return axios.post('a/upHelp', Qs.stringify(params))
  },
  /**
   * 删除帮助信息
   */
  delHelp (params) {
    return axios.post('a/delHelp', Qs.stringify(params))
  },
  /**
   * 设置系统基本参数
   */
  saveSystem (params) {
    return axios.post('a/saveSystem', Qs.stringify(params))
  },
  /**
   * 获取系统基本参数
   */
  getSystem (params) {
    return axios.get('a/getSystem', Qs.stringify(params))
  },
  /**
   * 添加文章
   */
  addArticle (params) {
    return axios.post('a/addArticle', Qs.stringify(params))
  },
  /**
   * 获取文章分页数据
   */
  getArticleAll (params) {
    return axios.post('a/getArticleAll', Qs.stringify(params))
  },
  /**
   * 修改文章状态
   */
  saveArticleState (params) {
    return axios.post('a/saveArticleState', Qs.stringify(params))
  },
  /**
   * 删除文章
   */
  delArticle (params) {
    return axios.post('a/delArticle', Qs.stringify(params))
  },
  /**
   * 获取单个文章
   */
  getOneArticle (params) {
    return axios.post('a/getOneArticle', Qs.stringify(params))
  },
  /**
   * 获取文章分类
   */
  getArticleTyps (params) {
    return axios.get('a/getArticleTyps', Qs.stringify(params))
  },
  /**
   * 修改文章
   */
  saveArticle (params) {
    return axios.post('a/saveArticle', Qs.stringify(params))
  },
  /**
   * 获取短信剩余条数
   */
  getSmsNum (params) {
    return axios.get('a/getSmsNum', Qs.stringify(params))
  },
  /**
   * 获取发送短信记录
   */
  getSmsSendingList (params) {
    return axios.post('a/getSmsSendingList', Qs.stringify(params))
  },
  /**
   * 添加医生
   */
  addDoctor (params) {
    return axios.post('a/addDoctor', Qs.stringify(params))
  },
  /**
   * 后台查看专家分页
   */
  getDoctorAll (params) {
    return axios.post('a/getDoctorAll', Qs.stringify(params))
  },
  /**
   * 医生状态修改
   */
  saveDoctorState (params) {
    return axios.post('a/saveDoctorState', Qs.stringify(params))
  },
  /**
   * 删除医生
   */
  delDoctor (params) {
    return axios.post('a/delDoctor', Qs.stringify(params))
  },
  /**
   * 获取单个医生信息
   */
  getOneDoctor (params) {
    return axios.post('a/getOneDoctor', Qs.stringify(params))
  },
  /**
   * 修改医生信息
   */
  saveDoctor (params) {
    return axios.post('a/saveDoctor', Qs.stringify(params))
  },
  /**
   * 退出登录
   */
  exitlogin (params) {
    return axios.post('a/exitlogin', Qs.stringify(params))
  },
  /**
   * 获取挂号分页
   */
  getRegisterList (params) {
    return axios.post('a/getRegisterList', Qs.stringify(params))
  },
  /**
   * 获取医生列表
   */
  getDoctorData (params) {
    return axios.post('a/getDoctorData', Qs.stringify(params))
  },
  /**
   * 获取首页显示数据
   */
  getIndexData (params) {
    return axios.get('a/getIndexData', Qs.stringify(params))
  },
  /**
   * 获取微信用户分页
   */
  getWxUserAll (params) {
    return axios.post('a/getWxUserAll', Qs.stringify(params))
  },
  /**
   * 获取微信用户地域列表
   */
  getAreaData (params) {
    return axios.get('a/getAreaData', Qs.stringify(params))
  },
  /**
   * 获取指定分类文章ALL
   */
  getArticleTypsAll (params) {
    return axios.post('a/getArticleTypsAll', Qs.stringify(params))
  },
  /**
   * 后台获取小程序路由
   */
  getWechatRoute (params) {
    return axios.post('a/getWechatRoute', Qs.stringify(params))
  },
  /**
   * 后台添加小程序路由
   */
  addWechatRoute (params) {
    return axios.post('a/addWechatRoute', Qs.stringify(params))
  },
  /**
   * 后台删除小程序路由
   */
  delWechatRoute (params) {
    return axios.post('a/delWechatRoute', Qs.stringify(params))
  },
  /**
   * 后台修改小程序路由
   */
  saveWechatRoute (params) {
    return axios.post('a/saveWechatRoute', Qs.stringify(params))
  },
  /**
   * 后台获取消息模板数据
   */
  getNewsMould (params) {
    return axios.post('a/getNewsMould', Qs.stringify(params))
  },
  /**
   * 后台添加消息模板
   */
  addNewsMould (params) {
    return axios.post('a/addNewsMould', Qs.stringify(params))
  },
  /**
   * 后台删除消息模板
   */
  delNewsMould (params) {
    return axios.post('a/delNewsMould', Qs.stringify(params))
  },
  /**
   * 后台修改消息模板
   */
  saveNewsMould (params) {
    return axios.post('a/saveNewsMould', Qs.stringify(params))
  },
  /**
   * 消息推送初始化数据
   */
  getNewsPushData (params) {
    return axios.get('a/getNewsPushData', Qs.stringify(params))
  },
  /**
   * 添加小程序路由组件初始化数据获取
   */
  getWechatRouterAddData (params) {
    return axios.get('a/getWechatRouterAddData', Qs.stringify(params))
  },
  /**
   * 获取指定模板id可推送的用户信息
   */
  getMouldPushUser (params) {
    return axios.post('a/getMouldPushUser', Qs.stringify(params))
  },
  /**
   * 检测模板是否符合发送规则并发送
   */
  testingMouldPush (params) {
    return axios.post('a/testingMouldPush', Qs.stringify(params))
  },
  /**
   * 获取推送任务列表
   */
  getPushTaskList (params) {
    return axios.post('a/getPushTaskList', Qs.stringify(params))
  },
  /**
   * 获取指定模板参数
   */
  getModular (params) {
    return axios.post('a/getModular', Qs.stringify(params))
  },
  /**
   * 保存指定模板参数
   */
  setModular (params) {
    return axios.post('a/setModular', Qs.stringify(params))
  },
  /**
   * 获取小程序首页模块数据
   */
  getInitialData (params) {
    return axios.post('a/getInitialData', Qs.stringify(params))
  },
  /**
   * 获取小程序病种页模块数据
   */
  getDiseaseData (params) {
    return axios.post('a/getDiseaseData', Qs.stringify(params))
  },
  /**
   * 保存首页模块排序
   */
  setInitialData (params) {
    return axios.post('a/setInitialData', Qs.stringify(params))
  },
  /**
   * 获取小程序链接
   */
  pushWxUrlData (params) {
    return axios.get('a/pushWxUrlData', Qs.stringify(params))
  },
  /**
   * 向微信服务器推送小程序页面链接，加速收录
   */
  pushWxUrl (params) {
    return axios.post('a/pushWxUrl', Qs.stringify(params))
  },
	/**
	 * 后台获取短信模板
	 */
	getSmsMould (params) {
	  return axios.post('a/getSmsMould', Qs.stringify(params))
	},
	/**
	 * 后台添加短信模板
	 */
	addSmsMould (params) {
	  return axios.post('a/addSmsMould', Qs.stringify(params))
	},
	/**
	 * 后台删除短信模板
	 */
	delSmsMould (params) {
	  return axios.post('a/delSmsMould', Qs.stringify(params))
	},
	/**
	 * 后台修改短信模板
	 */
	saveSmsMould (params) {
	  return axios.post('a/saveSmsMould', Qs.stringify(params))
	},
	/**
	 * 获取发送短信数据
	 */
	getSmsPushData (params) {
	  return axios.get('a/getSmsPushData', Qs.stringify(params))
	},
	/**
	 * 推送短信
	 */
	setSmsPushData (params) {
	  return axios.post('a/setSmsPushData', Qs.stringify(params))
	},
	/**
	 * 获取用户病例数据(分页查询)
	 */
	getWxUserCaseData (params) {
	  return axios.post('a/getWxUserCaseData', Qs.stringify(params))
	},
	/**
	 * 获取单个用户病例数据
	 */
	getWxUserCaseOneData (params) {
	  return axios.post('a/getWxUserCaseOneData', Qs.stringify(params))
	},
}


// WEBPACK FOOTER //
// ./src/api/index.js